<div class="rd-widget rd-widget-no-height-restriction" [style.height.px]="widgetHeight" *ngIf="widgetData">
  <table class="widget-flex" aria-hidden="true">
    <thead>
      <tr class="widget-ruller-flex">
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
        <th scope="col" class="widget-grid-column">&nbsp;</th>
      </tr>
    </thead>

    <tbody>
      <tr [hidden]="!editMode" *ngIf="!rdStorage.getAppPrintMode()">
        <td colspan="16" class="widgetImageTypePlaceholder">
          <table class="valuerSelection" aria-hidden="true">
            <tr>
              <td class="align-left">Valuer</td>
              <td>
                <kendo-dropdownlist [disabled]="signatureAndLicenseService.isDisabledUsers[currentLayoutIndex]"
                                    [data]="signatureAndLicenseService.dataUsers[currentLayoutIndex]"
                                    [value]="signatureAndLicenseService.selectedUser[currentLayoutIndex]"
                                    textField="userName"
                                    valueField="userId"
                                    (valueChange)="signatureAndLicenseService.handleUserChange(currentLayoutIndex, $event)">
                </kendo-dropdownlist>
              </td>
            </tr>
            <tr>
              <td class="align-left">License</td>
              <td>
                <kendo-dropdownlist [disabled]="signatureAndLicenseService.isDisabledLicenses[currentLayoutIndex]"
                                    [data]="signatureAndLicenseService.dataResultLicenses[currentLayoutIndex]"
                                    [value]="signatureAndLicenseService.selectedLicense[currentLayoutIndex]"
                                    textField="licenseName"
                                    valueField="licenseName"
                                    (valueChange)="signatureAndLicenseService.handleLicenseChange(currentLayoutIndex, $event)">
                </kendo-dropdownlist>
              </td>
            </tr>
          </table>
        </td>
      </tr>

      <tr [hidden]="editMode">
        <td class="widgetImagePlaceholder" colspan="16"
            [ngStyle]="{ 'background': 'url(' + getLicense() + ')'}">
        </td>
      </tr>
    </tbody>

  </table>
</div>
